(function () {

    var NO_IMAGE_SRC = '/lg5-common/images/icons/noimage.svg';

    window.handleImgError = function (img) {
        if (!img || img.getAttribute('data-img-fallback') === '1') {
            return;
        }
        img.setAttribute('data-img-fallback', '1');
        img.src = NO_IMAGE_SRC;
    };

    var listTemplate = '' +
        '{{#each (item, index) in list}}' +
        '    <li>' +
        '        <a href="{{item.detailHref}}">' +
        '            <div class="thumb">' +
        '                <span class="category">{{item.newsroomCategory}}</span>' +
        '                <img src="{{item.validFileMgmtNo}}" alt="{{#raw item.newsTitleText}}" onerror="handleImgError(this)">' +
        '            </div>' +
        '            <div class="cont-box">' +
        '                <div class="meta">' +
        '                    <span class="writer">{{item.postAuthorName}}</span>' +
        '                    <span class="date">{{item.postDate}}</span>' +
        '                </div>' +
        '                <p class="tit">{{#raw item.newsTitleText}}</p>' +
        '                <div class="desc">{{#raw item.newsContentText}}</div>' +
        '            </div>' +
        '        </a>' +
        '    </li>' +
        '{{/each}}';

    var NEWSROOM_API = '/ajax/v1/story/newsroom-list';

    var storyNewsRoom = {
        init: function () {
            var self = this;
            var $paginationContainer = $('div.story-list-wrap .pagination');

            $paginationContainer.css('pointer-events', 'none');

            vcui.require(['ui/pagination'], function () {
                self.setting();
                self.bindEvents();

                var urlParams = new URLSearchParams(window.location.search);
                self.requestData(urlParams, false, true);

                $paginationContainer.css('pointer-events', 'auto');
            });
        },

        setting: function () {
            var self = this;
            var $contents = $('div.story-list-wrap');
            self.$pagination = $contents.find('div.pagination').vcPagination();
        },

        bindEvents: function () {
            var self = this;

            self.$pagination.on('page_click', function (e, page) {
                var urlParams = new URLSearchParams(window.location.search);
                urlParams.set('page', page);
                self.requestData(urlParams);
            });

            $(window).on('popstate', function () {
                var urlParams = new URLSearchParams(window.location.search);
                self.requestData(urlParams, true);
            });
        },

        requestData: function (urlParams, skipHistoryUpdate, isInitial) {
            var self = this;
            var $contents = $('div.story-list-wrap');
            var $itemList = $contents.find('ul.story-list-box.newsRoom');
            var $count = $itemList.siblings('p.count').find('span');

            var params = {};
            urlParams.forEach(function (value, key) {
                params[key] = value;
            });

            if (!skipHistoryUpdate) {
                var queryString = urlParams.toString();
                if (queryString !== '') {
                    history.pushState(null, '', window.location.pathname + '?' + queryString);
                }
            }

            lgkorUI.requestKongAjax('displaysvc', NEWSROOM_API, {
                method: 'GET',
                data: params,
                success: function (response) {
                    var data = response.data;

                    $count.text(vcui.number.addComma(data.totalCount));

                    var listData = data && data.list instanceof Array ? data.list : [];
                    if (listData.length > 0) {
                        self.$pagination.show();
                        var querySuffix = window.location.search || '';
                        listData.forEach(function (item) {
                            item.detailHref = '/story/newsroom/' + item.postId + querySuffix;
                        });
                        $itemList.html(vcui.template(listTemplate, { list: listData }));

                        var imgs = $itemList[0].querySelectorAll('img');
                        for (var i = 0; i < imgs.length; i++) {
                            imgs[i].setAttribute('decoding', 'async');
                            if (i === 0) {
                                imgs[i].setAttribute('fetchpriority', 'high');
                            } else {
                                imgs[i].setAttribute('loading', 'lazy');
                            }
                        }

                        lgkorUI._addImgOnloadEvent();
                        $itemList.show();
                    } else {
                        $itemList.hide();
                        self.$pagination.hide();
                    }

                    self.$pagination.vcPagination('setPageInfo', {
                        page: data.page,
                        totalCount: data.totalPage
                    });

                    if (!isInitial) {
                        $itemList.find('li:first a').focus();
                    }
                },
                error: function (xhr, status, error) {
                    $itemList.hide();
                    self.$pagination.hide();
                    void 0;
                }
            }, true, true);
        }
    };

    $(document).ready(function () {

        if (!$('div.story-list-wrap ul.story-list-box.newsRoom').length) {
            return;
        }
        storyNewsRoom.init();
    });
})();
